import apiService from "@common/services/api.service";
import { API } from "@common/services/config";

export default {
  getKqsxResultData(date, city, spinnerConfig) {
    const config = {
      params: {
        date,
        city
      },
      spinnerConfig
    };
    return apiService.lotte.get(API.KQSX_RESULT, config);
  }
};
